import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { NavigationProvider } from "./context/navigation";
import { UsersProvider } from "./context/users";
import { Provider } from "react-redux";
import { HashRouter, Routes, Route } from "react-router-dom";
import { AuthProvider as LegacyAuthProvider } from "./context/AuthProvider";
import { store } from "./store";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "./theme/theme";

import { AuthProvider } from "./contexts/AuthContext";
import { ScriptModeProvider } from "./contexts/ScriptModeContext";
import { ThemeModeProvider } from "./contexts/ThemeModeContext";
import { ToastProvider } from "./components/ui/Toast";
import UpdateWatcher from "./components/ui/UpdateWatcher";

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);

root.render(
  <React.StrictMode>
    <HashRouter>
      <ThemeModeProvider>
      <ThemeProvider theme={muiTheme}>
        <Provider store={store}>
          <ScriptModeProvider>
            <ToastProvider>
              <AuthProvider>
                <UsersProvider>
                  <NavigationProvider>
                    <LegacyAuthProvider>
                      <Routes>
                        <Route path="/*" element={<App />} />
                      </Routes>
                      <UpdateWatcher />
                    </LegacyAuthProvider>
                  </NavigationProvider>
                </UsersProvider>
              </AuthProvider>
            </ToastProvider>
          </ScriptModeProvider>
        </Provider>
      </ThemeProvider>
      </ThemeModeProvider>
    </HashRouter>
  </React.StrictMode>
);
